module.exports = __webpack_public_path__ + "static/media/parkride.0992daf0.svg";